<template>
	<el-dialog
		class="l-dialog"
		custom-class="l-dialog-container"
		top="0"
		:close-on-click-modal="false"
		:modal-append-to-body="modalAppendToBody"
		:append-to-body="appendToBody"
		:width="width"
		v-bind="$attrs"
		v-on="$listeners"
		destroy-on-close
	>
		<slot></slot>
		<template v-slot:title>
			<slot name="title"></slot>
		</template>
	</el-dialog>
</template>

<script>
export default {
	name: "l-dialog-new",
	props: {
		width: {
			default: "600px",
		},
		appendToBody: {
			default: true,
		},
		modalAppendToBody: {
			default: false,
		},
	},
};
</script>

<style lang="scss" scoped>
.l-dialog {
	@include display-flex();
	@include align-items-center();
	::v-deep .el-dialog__footer {
		padding: 12px 20px;
	}

	::v-deep .el-dialog__body {
		padding-bottom: $dialog-footer-height;
		padding-top: 0;
		padding-left: 0;
		padding-right: 0;
		overflow: auto;
	}

	::v-deep .el-dialog__header {
		border-top: solid 4px $primary-color;
		border-bottom: dashed 1px $border-color-normal;
		padding-top: 12px;
		padding-bottom: 12px;
		height: $dialog-header-height;
	}

	::v-deep .el-dialog__title {
		color: $primary-color;
		font-size: 17px;
	}
}

::v-deep .l-dialog-container {
	max-width: 95%;
	margin-top: 0 !important;
	margin-bottom: 0 !important;
	height:70%;
}
</style>
